import React, { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import { ThemeProperties } from "./theme.types";
import { uglaTheme } from "./themes/ugla";
import { cosikaTheme } from "./themes/cosika";
import { storyTheme } from "./themes/story";

const themes: { [key: string]: ThemeProperties } = {
  default: uglaTheme, // Fallback to default theme
  [uglaTheme.name]: uglaTheme,
  [cosikaTheme.name]: cosikaTheme,
  [storyTheme.name]: storyTheme,
  // Add more themes here as needed
};

const resolveTheme = (): ThemeProperties => {
  const hostName = window.location.hostname;

  // Extract the domaine name from the hostname (e.g., "example" from "app.example.com")
  const host = hostName.split(".").at(-2)?.toLowerCase() || "default";

  // Check if the host matches a theme
  // Fallback to default theme if no match is found
  return themes[host] || themes.default;
};

/**
 * Theme Component that wraps an application and provides a theme based on the current hostname.
 *
 * @example
 * // Usage:
 * <Theme>
 *     <YourComponents />
 * </Theme>
 *
 * // You can access theme properties in styled-components, if the component is wrapped in the Theme component:
 * const StyledDiv = styled.div`
 *     css-prop: ${props => props.theme.propertyName};
 * `;
 */
const Theme: React.FC<any> = ({ children }) => {
  const [theme] = useState<ThemeProperties>(resolveTheme());

  useEffect(() => {
    // Set the document title based on the theme
    document.title = theme.title;

    // Set the favicon dynamically based on the theme
    const faviconLink = document.getElementById("favicon") as HTMLLinkElement;
    if (faviconLink) {
      faviconLink.href = theme.assets.favicon;
    }
  }, [theme]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Theme;
